module.exports = __webpack_public_path__ + "img/_check.0f3e78db.svg";